function omit<T, K extends keyof T>(obj: T, keys: K[]): Omit<T, K> {
  if (typeof obj !== "object" || obj === null) {
    return obj;
  }

  const result = { ...obj };

  for (const key of keys) {
    Reflect.deleteProperty(result, key);
  }

  return result;
}

function pick<T, K extends keyof T>(obj: T, keys: K[]): Pick<T, K> {
  if (typeof obj !== "object" || obj === null) {
    return obj;
  }

  const result = {} as Pick<T, K>;

  for (const key of keys) {
    if (Reflect.has(obj, key)) {
      result[key] = Reflect.get(obj, key);
    }
  }

  return result;
}

export const Record = Object.freeze({ omit, pick });
